import React from "react";
import Helmet from "react-helmet";

interface HeaderProps {
    title: string;
};

export default function HtmlHeader(props: HeaderProps) {
    //const [title] = React.useState(props.title ?? "Mirzoyan");

    return <Helmet>
        <title>{props.title}</title>
    </Helmet>;
}

